
import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { OnTabKeyPress } from "../../../../../../utils/cssUtils";
import { computationRules1 } from "./DrugScreenCollection";

export const ScreeningBloodPressure = (props)=>{
    // console.log('props.lookupsOptions',props.lookupsOptions);
    const stackedFieldStyle = {
        layout: 'stacked',
        showContainerBorder: false,
        labelWrap: false,
        isLabel: false,
      };
    const charts = [{
        type:'Grid',
        col:'col-md-3',
        data:[{
            type:"PatientDetails",
            employeeDetails:props.employeeDetails,
            visitDetails:props.visitDetails
        },{
            type:"CompanyDetails",
            companyDetails:props.companyDetails
        }],
    },{
        type:'Tab',
        col:'col-md-9',
        data:[
            {
                id:'blood_pressure_details',
                label:'Blood Pressure Details',
                data:[
        {
            label:'Activity Details - '+props.activityName,
            fields:[
               
            {
                label:'Height',
                placeholder:'Feet',
                col:'col-4',
                type:'Number',
                name:'height_feet',
                id:'height_feet',
                
            },
            {
                label:'',
                isLabel:false,
                placeholder:'Inches',
                col:'col-2',
                type:'Decimal',
                name:'height_inches',
                id:'height_inches',
                
            },
            {
                label:'Weight (In Pounds)',
                placeholder:'Pounds',
                col:'col-6',
                type:'Number',
                name:'weight_pounds',
                id:'weight_pounds',
                
            },
            {
                label:'Pulse Rate',
                type:'Number',
                rangeMin:60,
                rangeMax:100,
                name:'pulse_rate',
                id:'pulse_rate',
        },
        {
            label:'Pulse Rhythm Regular',
            type:'RadioGroup',
            name:'pulse_rhythm_regular',
            id:'pulse_rhythm_regular',
            options:[{label:'Yes',value:1},{label:'No',value:0}],
        },
        ]
        }, { 
            label:' Blood Pressure Reading (Systolic / Diastolic)',
            fields:[
                {
                    label:'Systolic',
                    col:'col-2',
                    type:'Label',
                },
                {
                label:' Sitting',
                col:'col-4',
                type:'Number',
                rangeMax:140,
                name:'sitting_systolic',
                id:'sitting_systolic',
                onKeyPress:(event)=>OnTabKeyPress(event,"sitting_diastolic",null),
            },
            {
                label:'Second reading (optional)',
                col:'col-6',
                type:'Number',
                rangeMax:140,
                name:'second_reading_systolic',
                id:'second_reading_systolic',
            },
            {
                label:'Diastolic',
                col:'col-2',
                type:'Label',
            },
            {
                label:' Sitting',
                col:'col-4',
                type:'Number',
                rangeMax:90,
                name:'sitting_diastolic',
                id:'sitting_diastolic',
                onKeyPress:(event)=>OnTabKeyPress(event,"notes","sitting_systolic"),
            },
            {
                label:'Second reading (optional)',
                col:'col-6',
                type:'Number',
                rangeMax:90,
                name:'second_reading_diastolic',
                id:'second_reading_diastolic',
            },
            // {
            //     label:'Blood Pressure Ranges',
            //     col:'col-12',
            //     type:'UnorderedList',
            //     notes:[
            //         <span><b>Normal</b>: Systolic less than 120 mmHg and diastolic less than 80 mmHg </span>,
            //         <span><b>Elevated</b>: Systolic 120-129 mmHg and diastolic less than 80 mmHg</span>,
            //         <span><b>Stage 1 hypertension</b>    : Systolic 130-139 mmHg or diastolic 80-89 mmHg</span>,
            //         <span><b>Stage 2 hypertension</b>    : Systolic 140 mmHg or higher or diastolic 90 mmHg or higher</span>,
            //         <span><b>Hypertensive</b>     : Systolic higher than 180 mmHg and/or diastolic higher than 120 mmHg</span>],
            // },
            
        ]
        },
   
        {
            label: "Notes",
            // labelStyle: "fw-semibold",
            fieldProps: stackedFieldStyle,
            fields: [
              {
                type: "NewTextArea",
                label: "Notes",
                placeholder: "Add Comments",
                className: "form-control form-control-solid",
                name: "notes",
                col: "col-12 border-0",
              },
              // {
            //     label:'Suggested Result',
            //     type:'TextInput',
            //     disabled:true,
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'suggested_status',
            // },
            // {
            //     type:'Blank',
            //     name:'blank'
            // },
            // {
            //     label:'Final Determination Result',
            //     type:'SelectList',
            //     options:isSet(props.lookupsOptions['chartResult'],[]),
            //     name:'status',
            // },
            ]
          },
        {
            label: 'Review / Completion',
            // labelStyle: 'fw-semibold',
            fields: [
                {
                    type: 'ProviderSignOff',
                    col: 'col-12',
                    fields: [
                        { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                        { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                        { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                        // { label : "Suggested Result", disabled:true, placeholder:'Not Started',type: "TextInput", name: "suggested_status", col: "col-6"},
                        // { label : "Final Results", type: "SelectList", name: "status", col: "col-12",options:isSet(props.lookupsOptions['chartResult'],[]),statusBasedColor: true },
                        { label : "Final Results", type: "SelectList", name: "status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Normal','Abnormal','Negative','Positive','Dispensed','Administered','Failed','Passed','Non-Negative','Cancelled','Inconclusive']),statusBasedColor: true },
                        // { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Ordered','Completed','Cancelled']),statusBasedColor: true },
                        { label : "Activity Status", type: "SelectList", name: "activity_status", col: "col-12", options: optionsToKeyValuePairs(['Not Started','Pending','Pending Lab Confirmation','Pending MRO Confirmation','Ready for Review','Completed','Cancelled']),statusBasedColor: true },
                    ],
                },
            ],
        }
                ]
            },
            {
                id:'Images',
                label:'Images',
                data:[]
            }
        ]
    }];
    const defaultValue = {
        status:'Not Started',
        suggested_status:'Not Started',
        activity_status:'Not Started',
        // reason:'Pre-employment'
    };
    const headers = [{
        type: 'Tab',
        data: [
            {
                label: 'Blood Pressure Details',
                id: 'blood_pressure_details'
            },
            {
                label: 'Images',
                id: 'Images'
            }
        ]
    }];
    return {charts,defaultValue,headers,computationFunction: (formData,key) => ({...computationRules(formData,key), ...computationRules1(formData,key)})};
}


const computationRules = (formData,key)=>{
   const pulse = isSet(formData.pulse_rate,'');
   const systolic = isSet(formData.sitting_systolic,'');
   const systolic2 = isSet(formData.second_reading_systolic,'');
   const diastolic = isSet(formData.sitting_diastolic,'');
   const diastolic2 = isSet(formData.second_reading_diastolic,'');
   let status = evaluateStatus(pulse,systolic,diastolic);
   let activity_status = 'Not Started';
   if(status==='Not Started'){
    activity_status = 'Not Started';
   }else if(status==='Failed'){
    activity_status = 'Completed';
   }else if(status==='Pending'){
    activity_status = 'Pending';
   }else if(status==='Normal'){
    activity_status = 'Completed';
   }
   return (key==='status' || key==='activity_status')?{}:{'status':status,'suggested_status':status,'activity_status':activity_status};
}


const evaluateStatus = (pulse, systolic, diastolic)=> {
    // Check if any of the parameters are empty
    if (pulse === '' && systolic === '' && diastolic === '') {
        return 'Not Started';
    }
    if (pulse === '' || systolic === '' || diastolic === '') {
       return 'Pending';
    }
    
  
    // Check if pulse is out of range
    if (pulse < 60 || pulse > 100) {
      return 'Failed';
    }
  
    // Check if systolic is out of range
    if (systolic < 0 || systolic > 140) {
      return 'Failed';
    }
  
    // Check if diastolic is out of range
    if (diastolic < 0 || diastolic > 90) {
      return 'Failed';
    }
  
    // If all parameters are within range, return 'passed'
    return 'Passed';
  }
  